import { getHarnessWebUrl } from '@/apps/harness/utils/harness';

export const CREATION_IDEA_MAX_LENGTH = 500;
export const isBusinessId = (value) =>
  typeof value === 'string' &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);

export const getCreationIdeaLength = (value) => Array.from(value).length;

export const validateCreationEntry = (input) => {
  if (!input || typeof input !== 'object' || Array.isArray(input)) {
    throw new Error('请选择一个创作入口');
  }
  const entries = Object.entries(input);
  if (entries.length !== 1) {
    throw new Error('请选择一个创作入口');
  }
  const [key, value] = entries[0];
  if (!['seedPlanId', 'hotPotId'].includes(key) || !isBusinessId(value)) {
    throw new Error('创作来源无效，请重新选择');
  }
  return { [key]: value };
};

export const getCreationInput = (input) => {
  if (input && Object.hasOwn(input, 'idea')) {
    if (Object.keys(input).length !== 1) {
      throw new Error('请选择一个创作入口');
    }
    if (typeof input.idea !== 'string') throw new Error('请输入 1 至 500 字的创作想法');
    const idea = input.idea.trim();
    if (!idea || getCreationIdeaLength(idea) > CREATION_IDEA_MAX_LENGTH) {
      throw new Error('请输入 1 至 500 字的创作想法');
    }
    return { idea };
  }
  return validateCreationEntry(input);
};

export const getHarnessCreationUrl = (organizationId, { threadId, ...input }) => {
  if (!isBusinessId(threadId)) throw new Error('创作记录无效');
  const normalized = Object.keys(input).length ? getCreationInput(input) : {};
  const params = new URLSearchParams({ mode: 'harness', threadId, ...normalized });
  params.set('view', 'mini');
  return `${getHarnessWebUrl(organizationId)}?${params}`;
};

export const createHarnessSourceEntry = ({ record, seedType }) => {
  if (!['seedPlan', 'hotPot'].includes(seedType) || !isBusinessId(record?.id)) {
    throw new Error('创作来源无效，请重新选择');
  }
  return {
    input: { [`${seedType}Id`]: record.id },
  };
};

export const shouldUseHarnessCreation = (query, record) =>
  record
    ? record.mode === 'harness'
    : !(Array.isArray(query.threadId) ? query.threadId.at(-1) : query.threadId);
